import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { CreateApplicationDetailsItamsConstants } from "./create-application-details-itams.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { InformalTradeService } from "../../../../../shared/services/modules/informal-trade.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
let CreateApplicationDetailsItamsComponent = class CreateApplicationDetailsItamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    recipientListService;
    informalTradeService;
    changeDetectorRefs;
    // Labels
    descriptionLabel = CreateApplicationDetailsItamsConstants.DESCRIPTION_LABEL;
    applicationTypeLabel = CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LABEL;
    tradingGoodsLabel = CreateApplicationDetailsItamsConstants.TRADING_GOODS_LABEL;
    tradingGoodsDescriptionLabel = CreateApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_LABEL;
    previousApplicationReferenceNumberLabel = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL;
    verifyReferenceNumberLabel = CreateApplicationDetailsItamsConstants.VERIFY_REFERENCE_NUMBER_LABEL;
    baysFormGroupName = CreateApplicationDetailsItamsConstants.BAYS_FORM_GROUP_NAME;
    baysFormControl = CreateApplicationDetailsItamsConstants.BAYS_FORM_CONTROL_NAME;
    referenceNumberVerifiedLabel = CreateApplicationDetailsItamsConstants.REFERENCE_VERIFIED_LABEL;
    unverifiedReferenceNumberLabel = CreateApplicationDetailsItamsConstants.REFERENCE_NOT_VERIFIED_LABEL;
    // Form controls
    descriptionFormControlName = CreateApplicationDetailsItamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    tradeGoodsFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_CONTROL_NAME;
    tradingGoodsDescriptionFormControlName = CreateApplicationDetailsItamsConstants.TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME;
    previousApplicationReferenceNumberFormControlName = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME;
    previousApplicationValidatedFormControlName = CreateApplicationDetailsItamsConstants.PREVIOUS_APPLICATION_VALIDATED_CONTROL_NAME;
    tradersFormGroupName = CreateApplicationDetailsItamsConstants.TRADERS_FORM_GROUP_NAME;
    tradersFormControlName = CreateApplicationDetailsItamsConstants.TRADERS_FORM_CONTROL_NAME;
    centroidFromControlName = CreateApplicationDetailsItamsConstants.CENTROID_FORM_CONTROL_NAME;
    // constants
    validationMessages = CreateApplicationDetailsItamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    deleteTradingGoodsLabel = CreateApplicationDetailsItamsConstants.REMOVE_TRADING_GOODS_LABEL;
    addTradingGoodsLabel = CreateApplicationDetailsItamsConstants.ADD_TRADING_GOODS_LABEL;
    // variables
    detailsForm;
    applicationTypes = [];
    tradingGoods = [];
    lastSelectedTradingGood = null;
    tradingGoodIsRequired = true;
    showPreviousApplicationReferenceNumberField = false;
    showVerifyReferenceNumberButton = false;
    hideRemovalAndAddButton = false;
    showReferenceNumberVerifiedLabel = false;
    showUnVerifiedReferenceNumberLabel = false;
    showSelectedForm = false;
    tradeGoodsFormArray = CreateApplicationDetailsItamsConstants.TRADING_GOODS_FORM_ARRAY_NAME;
    showTradingGoodsButtons = true;
    isReferenceNumberVerified = false;
    getInformalTradeApplicationObservableSubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    clearApplicationVerificationSubjectSubscription;
    getTradersSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, appController, recipientListService, informalTradeService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.recipientListService = recipientListService;
        this.informalTradeService = informalTradeService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.getMetadata();
    }
    ngOnInit() {
        this.initForm();
        if (this.appController.moduleSimulateMode) {
            let defaults = SimulationUtils.simulate_Create_Application();
            this.applicationTypes = defaults.applicationType;
            this.tradingGoods = defaults.tradingGoods;
        }
        else {
            const isLookupsAlreadyLoaded = this.checkIfLookupsAreLoaded();
            if (!isLookupsAlreadyLoaded) {
                this.getLookups();
            }
        }
        this.setupSubscribers();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    getTradingGoods() {
        const tradeGoodsFormArray = this.detailsForm.get("tradeGoods");
        return tradeGoodsFormArray;
    }
    loadMetadata() {
    }
    onTradingGoodsSelected($event, i) {
        const selectedTradingGood = $event.target?.value;
        const tradingGoods = this.getTradingGoods().controls;
        // Check if the selected item is "Other"
        if (selectedTradingGood && selectedTradingGood.trim().toLowerCase() === "other") {
            this.lastSelectedTradingGood = selectedTradingGood;
            const tradingGoodsDescriptionFormControl = tradingGoods[i].get(this.tradingGoodsDescriptionFormControlName);
            tradingGoodsDescriptionFormControl.enable();
            tradingGoodsDescriptionFormControl.reset();
            tradingGoodsDescriptionFormControl.addValidators(Validators.required);
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            this.tradingGoodIsRequired = true;
            // Check for duplicate "Other" with the same description
            tradingGoodsDescriptionFormControl.valueChanges.subscribe(description => {
                const isDuplicateDescription = tradingGoods.some((control, index) => {
                    if (index !== i) {
                        const controlDescription = control.get(this.tradingGoodsDescriptionFormControlName)?.value?.trim().toLowerCase();
                        return control.get('tradeGoods')?.value.trim().toLowerCase() === "other" && controlDescription === description?.trim().toLowerCase();
                    }
                    return false;
                });
                if (isDuplicateDescription) {
                    this.appController.showMessage(CreateApplicationDetailsItamsConstants.DUPLICATE_ERROR_DESCRIPTION, AlertType.Error);
                    //tradingGoodsDescriptionFormControl.setValue(null);
                }
            });
        }
        else {
            // Check for duplicates among other selected goods
            const isDuplicate = tradingGoods.some((control, index) => {
                return index !== i && control.get('tradeGoods')?.value === selectedTradingGood;
            });
            if (isDuplicate) {
                this.appController.showMessage(CreateApplicationDetailsItamsConstants.DUPLICATE_ERROR_TRADE_GOODS, AlertType.Error);
                const tradingGoodFormControl = tradingGoods[i].get('tradeGoods');
                tradingGoodFormControl.setValue(null);
                return;
            }
            this.lastSelectedTradingGood = selectedTradingGood;
            const tradingGoodsDescriptionFormControl = tradingGoods[i].get(this.tradingGoodsDescriptionFormControlName);
            tradingGoodsDescriptionFormControl.clearValidators();
            tradingGoodsDescriptionFormControl.updateValueAndValidity();
            tradingGoodsDescriptionFormControl.disable();
            this.tradingGoodIsRequired = false;
        }
        this.changeDetectorRefs.detectChanges();
    }
    onApplicationTypeSelected($event) {
        const selectedApplicationType = $event.target?.value;
        const previousApplicationReferenceNumberFormControl = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName);
        if (selectedApplicationType && selectedApplicationType.trim().toLowerCase() === "renewal") {
            previousApplicationReferenceNumberFormControl.addValidators(Validators.required);
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.showPreviousApplicationReferenceNumberField = true;
            this.showVerifyReferenceNumberButton = true;
            this.hideRemovalAndAddButton = true;
            this.isReferenceNumberVerified = true;
            this.showSelectedForm = true;
        }
        else {
            previousApplicationReferenceNumberFormControl.clearValidators();
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.resetTradingGoodsArray();
            this.showPreviousApplicationReferenceNumberField = false;
            this.showVerifyReferenceNumberButton = false;
            this.hideRemovalAndAddButton = false;
            this.showSelectedForm = true;
            this.showTradingGoodsButtons = true;
        }
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(CreateApplicationDetailsItamsConstants.DETAILS_FORM_GROUP_NAME);
        if (this.detailsForm.pristine) {
            this.getTradingGoods().clear();
            this.onBtnAddTradingGoodsClicked();
        }
        this.changeDetectorRefs.detectChanges();
    }
    getLookups() {
        const params = {
            $filter: `(moduleId eq ${this.appController.selectedModuleID}) and ((name eq '${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}' and deleted eq false) or (name eq '${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}' and deleted eq false))`
        };
        this.createApplicationService
            .getLookupsObservable(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsItamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const tradingGoods = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.trim().toLowerCase() === `${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME?.trim().toLowerCase()}`) {
                    tradingGoods.push(JSON.parse(item.content));
                }
            });
            if (applicationTypes && applicationTypes.length > 0) {
                applicationTypes.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
            }
            if (tradingGoods && tradingGoods.length > 0) {
                tradingGoods.sort((a, b) => 0 - (a.value.toLowerCase() > b.value.toLowerCase() ? -1 : 1));
            }
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME}`, applicationTypes);
            this.aflaModuleStrategyService.lookups.set(`${CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME}`, tradingGoods);
            this.applicationTypes = applicationTypes;
            this.tradingGoods = tradingGoods;
            this.changeDetectorRefs.detectChanges();
        }
    }
    onVerifyReferenceNumber() {
        const previousApplicationReferenceNumber = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName).value;
        this.getApplicationByReferenceNumber(previousApplicationReferenceNumber);
    }
    getApplicationByReferenceNumber(previousApplicationReferenceNumber) {
        const params = {
            $filter: `referenceNumber eq '${previousApplicationReferenceNumber}' and deleted eq false`,
            $expand: "bays,tradeGoods,status"
        };
        this.getInformalTradeApplicationObservableSubscription = this.informalTradeService.getInformalTradeApplicationObservable(params).subscribe({
            next: (response) => {
                if (response && response.length > 0) {
                    const application = response[0];
                    this.handleApplicationFound(application);
                }
                else {
                    this.handleApplicationNotVerified();
                }
                this.changeDetectorRefs.detectChanges();
            },
            error: (err) => {
                this.appController.handleServerErrorMessage("get applications", err, CRUDOperation.Get);
            }
        });
    }
    handleApplicationFound(application) {
        const applicationStatus = application.status.workflowSection;
        const applicationPercentageComplete = application.status.percentageComplete;
        if (applicationStatus?.toLowerCase() === "closed" || applicationPercentageComplete === 100) {
            this.showReferenceNumberVerifiedLabel = true;
            this.showUnVerifiedReferenceNumberLabel = false;
            this.isReferenceNumberVerified = true;
            this.populateTradingGoodsFieldsFromPreviousApplication(application);
            this.populateBaysFieldsFromPreviousApplication(application);
            this.getTraders(application);
        }
        else {
            this.appController.showMessage(`The application with reference number ${application.referenceNumber} cannot be used as it is still active. Please try another application`, AlertType.Warning);
        }
    }
    populateTradingGoodsFieldsFromPreviousApplication(application) {
        const savedTradingGoods = application.tradeGoods;
        const tradingGoods = this.getTradingGoods();
        this.detailsForm.get(this.previousApplicationValidatedFormControlName).setValue(true);
        if (savedTradingGoods && savedTradingGoods.length > 0) {
            this.showTradingGoodsButtons = false;
            tradingGoods.clear();
            savedTradingGoods.forEach((tradeGood) => {
                const tradingGoodFormGroup = new FormGroup({
                    id: new FormControl(tradeGood.id),
                    tradeGoods: new FormControl({ value: tradeGood.tradeGoods, disabled: true }, [Validators.required]),
                    tradingGoodsDescription: new FormControl({ value: tradeGood.description, disabled: true })
                });
                tradingGoods.push(tradingGoodFormGroup);
            });
        }
    }
    enableTradingGoodsFields() {
        this.getTradingGoods().enable();
    }
    resetTradingGoodsFields() {
        this.getTradingGoods().reset();
    }
    handleApplicationNotVerified() {
        this.showReferenceNumberVerifiedLabel = false;
        this.showTradingGoodsButtons = true;
        this.showUnVerifiedReferenceNumberLabel = true;
        this.enableTradingGoodsFields();
        this.resetTradingGoodsFields();
        this.resetBays();
        this.resetTraders();
        this.appController.showMessage("Application with matching reference number could not be found", AlertType.Warning);
    }
    populateTradersFromPreviousApplication(application) {
        const tradersFormGroup = this.aflaModuleStrategyService.form.get(this.tradersFormGroupName);
        const tradersFormControl = tradersFormGroup.get(this.tradersFormControlName);
        const traders = application.traders;
        this.recipientListService.setRecipients(traders, true, tradersFormControl);
        this.createApplicationService.$removeTradersRecipientListButtonsSubject.next(true);
    }
    populateBaysFieldsFromPreviousApplication(application) {
        const savedApplicationBays = application.bays;
        const applicationBaysFormGroup = this.aflaModuleStrategyService.form.get(this.baysFormGroupName);
        const savedApplicationBaysFormControl = applicationBaysFormGroup.get(this.baysFormControl);
        savedApplicationBaysFormControl.clear();
        if (savedApplicationBays && savedApplicationBays.length > 0) {
            savedApplicationBays.forEach((applicationBay) => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(applicationBay.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const formGroup = new FormGroup({
                    id: new FormControl(applicationBay.id),
                    bay: new FormControl(applicationBay),
                    address: new FormControl({ value: applicationBay.address, disabled: true }, [Validators.required]),
                    geometry: new FormControl(geom),
                    bayNumber: new FormControl({ value: applicationBay.bayNumber, disabled: true }),
                    baySize: new FormControl({ value: applicationBay.baySize, disabled: true }),
                    centroid: new FormControl(null, [Validators.required])
                });
                this.setTrueCentroid(geometryArc, formGroup, savedApplicationBaysFormControl);
            });
        }
    }
    setTrueCentroid(geometryArc, newBayFormGroup, bayControl) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newBayFormGroup.get(this.centroidFromControlName).setValue(response.results[0].value);
                bayControl.push(newBayFormGroup);
                this.createApplicationService.$removeShowBaySubject.next(true);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsItamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    subscribeToClearApplicationVerificationSubject() {
        this.clearApplicationVerificationSubjectSubscription = this.createApplicationService.$clearApplicationVerificationSubject.subscribe({
            next: (clearApplicationVerificationData) => {
                if (clearApplicationVerificationData) {
                    this.tradingGoodIsRequired = false;
                    this.showPreviousApplicationReferenceNumberField = false;
                    this.showReferenceNumberVerifiedLabel = false;
                    this.showVerifyReferenceNumberButton = false;
                    this.hideRemovalAndAddButton = false;
                    this.showUnVerifiedReferenceNumberLabel = false;
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    setupSubscribers() {
        this.subscribeToClearApplicationVerificationSubject();
    }
    checkIfLookupsAreLoaded() {
        let areLookupsLoaded = false;
        this.applicationTypes = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsItamsConstants.APPLICATION_TYPE_LOOKUP_NAME);
        this.tradingGoods = this.aflaModuleStrategyService.lookups.get(CreateApplicationDetailsItamsConstants.TRADING_GOODS_LOOKUP_NAME);
        if (this.applicationTypes && this.applicationTypes.length > 0 && this.tradingGoods && this.tradingGoods.length > 0) {
            areLookupsLoaded = true;
        }
        return areLookupsLoaded;
    }
    ngAfterViewInit() {
        const previousApplicationValidated = this.detailsForm.get("previousApplicationValidated").value;
        const selectedApplicationType = this.detailsForm.get("type").value;
        const previousApplicationReferenceNumberFormControl = this.detailsForm.get(this.previousApplicationReferenceNumberFormControlName);
        if (selectedApplicationType && selectedApplicationType.trim().toLowerCase() === "renewal") {
            previousApplicationReferenceNumberFormControl.addValidators(Validators.required);
            previousApplicationReferenceNumberFormControl.updateValueAndValidity();
            this.showPreviousApplicationReferenceNumberField = true;
            this.showVerifyReferenceNumberButton = true;
            this.hideRemovalAndAddButton = true;
            if (previousApplicationValidated) {
                this.showReferenceNumberVerifiedLabel = true;
                this.showUnVerifiedReferenceNumberLabel = false;
                this.hideRemovalAndAddButton = true;
            }
            else {
                this.showReferenceNumberVerifiedLabel = false;
                this.showUnVerifiedReferenceNumberLabel = true;
                this.hideRemovalAndAddButton = false;
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    onBtnRemoveTradingGoods(i) {
        const controls = this.getTradingGoods();
        if (controls.controls.length > 1) {
            controls.removeAt(i);
        }
    }
    onBtnAddTradingGoodsClicked() {
        const tradingGoodsControl = this.getTradingGoods();
        const tradingGoodsGroup = new FormGroup({
            tradeGoods: new FormControl(null, [Validators.required]),
            tradingGoodsDescription: new FormControl({ value: null, disabled: true })
        });
        tradingGoodsControl.push(tradingGoodsGroup);
    }
    resetTradingGoodsArray() {
        this.getTradingGoods().clear();
        this.onBtnAddTradingGoodsClicked();
    }
    resetBays() {
        const applicationBaysFormGroup = this.aflaModuleStrategyService.form.get(this.baysFormGroupName);
        const savedApplicationBaysFormControl = applicationBaysFormGroup.get(this.baysFormControl);
        savedApplicationBaysFormControl.clear();
        savedApplicationBaysFormControl.reset();
    }
    resetTraders() {
        const tradersFormGroup = this.aflaModuleStrategyService.form.get(this.tradersFormGroupName);
        const tradersFormControl = tradersFormGroup.get(this.tradersFormControlName);
        tradersFormControl.reset();
        this.createApplicationService.$removeTradersRecipientListButtonsSubject.next(false);
    }
    getTraders(application) {
        this.getTradersSubscription = this.informalTradeService.getTradersObservable(application.jobId).subscribe({
            next: (recipientResponse) => {
                if (recipientResponse && recipientResponse.length > 0) {
                    application.traders = recipientResponse;
                    this.populateTradersFromPreviousApplication(application);
                }
                else {
                    this.populateTradersFromPreviousApplication(application);
                }
            }, error: err => {
                this.appController.handleServerErrorMessage("traders", err, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: RecipientListService },
        { type: InformalTradeService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsItamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsItamsComponent);
export { CreateApplicationDetailsItamsComponent };
